(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crm-geburtstag-set"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BREAKPOINT = 1024;

    function syncActiveStep(root, slider) {
      if (window.innerWidth > BREAKPOINT) return;
      if (!slider) return;
      var activeStep = null;
      var selectedSlide = slider.querySelector('cs-slide.is-selected, cs-slide.is_selected');
      if (selectedSlide) activeStep = selectedSlide.getAttribute('data-step');
      if (!activeStep && slider.embla && typeof slider.embla.selectedScrollSnap === 'function') {
        var slides = slider.querySelectorAll('cs-slide');
        var idx = slider.embla.selectedScrollSnap();
        if (slides[idx]) activeStep = slides[idx].getAttribute('data-step');
      }
      if (!activeStep) {
        selectedSlide = slider.querySelector('cs-slide');
        if (selectedSlide) activeStep = selectedSlide.getAttribute('data-step');
      }
      if (!activeStep) return;
      root.querySelectorAll('.bday-step-number[data-step]').forEach(function (el) {
        el.classList.toggle('active', el.getAttribute('data-step') === activeStep);
      });
    }

    function bindSlider(root, slider) {
      var sync = function () { syncActiveStep(root, slider); };
      var initialStep = parseInt(slider.getAttribute('data-active-step-mobile'), 10);
      var boundAt = Date.now();
      var reapplyInitialIfEarly = function () {
        if (window.innerWidth > BREAKPOINT) return;
        if (!initialStep || initialStep <= 1) return;
        if (Date.now() - boundAt > 4000) return; // nur kurz nach dem Laden, nicht bei späterem Swipen
        scrollToStep(slider, initialStep, false);
      };
      if (slider.embla && typeof slider.embla.on === 'function') {
        slider.embla.on('select', sync);
        slider.embla.on('reInit', function () { reapplyInitialIfEarly(); sync(); });
        slider.embla.on('settle', sync);
      } else {
        slider.addEventListener('init', sync, { once: true });
      }
      var slides = slider.querySelector('cs-slides');
      if (slides && typeof MutationObserver !== 'undefined') {
        new MutationObserver(sync).observe(slides, { subtree: true, attributes: true, attributeFilter: ['class'] });
      }
      sync();
      setTimeout(sync, 0);
    }

    function scrollToStep(slider, step, animate, attemptsLeft, settle) {
      var slides = slider.querySelectorAll('cs-slide');
      var targetIndex = -1;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-step') === String(step)) { targetIndex = i; break; }
      }
      if (targetIndex < 0) return;

      if (slider.embla && typeof slider.embla.scrollTo === 'function') {
        slider.embla.scrollTo(targetIndex, animate);
        // Ein Nach-Schlag nach kurzer Verzögerung: falls Embla beim ersten Aufruf die
        // Breiten noch nicht final berechnet hatte, korrigiert dieser zweite Aufruf das.
        if (!settle) {
          setTimeout(function () { scrollToStep(slider, step, true, 0, true); }, 250);
        }
        return;
      }

      // Embla ist noch nicht bereit — statt auf ein bestimmtes Event zu warten (dessen exakter
      // Name/Zeitpunkt bei clever-slider nicht sicher ist), einfach kurz erneut prüfen.
      if (typeof attemptsLeft === 'undefined') attemptsLeft = 40; // ~4s bei 100ms Abstand
      if (attemptsLeft <= 0) return;
      setTimeout(function () {
        scrollToStep(slider, step, animate, attemptsLeft - 1, settle);
      }, 100);
    }

    function jumpToActive(slider) {
      if (window.innerWidth > BREAKPOINT) return;
      var step = parseInt(slider.getAttribute('data-active-step-mobile'), 10);
      if (!step || step <= 1) return;
      scrollToStep(slider, step, true);
    }

    // Klick auf eine Zahl (mobil) springt im Carousel zum jeweiligen Produkt.
    // Auf Desktop existiert kein Carousel an dieser Stelle, der Klick bleibt dort wirkungslos.
    function bindStepClicks(block, slider) {
      block.querySelectorAll('.bday-step-cell[data-step]').forEach(function (cell) {
        cell.addEventListener('click', function () {
          if (window.innerWidth > BREAKPOINT) return;
          scrollToStep(slider, cell.getAttribute('data-step'), false);
        });
      });
    }

    function initBlock(block) {
      if (block.dataset.bdayInit) return;
      block.dataset.bdayInit = '1';
      block.querySelectorAll('clever-slider[data-active-step-mobile]').forEach(function (slider) {
        bindSlider(block, slider);
        jumpToActive(slider);
        bindStepClicks(block, slider);
        syncActiveStep(block, slider);
      });
    }

    function init() {
      document.querySelectorAll('.bday-block').forEach(initBlock);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    // Theme-Editor lädt die Section per AJAX neu (kein DOMContentLoaded) — ohne das hier
    // bleibt eine frisch nachgeladene Instanz komplett unverdrahtet (kein Klick, kein Sync).
    // init() ist dank der bdayInit-Markierung idempotent, kann also gefahrlos erneut laufen.
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tabs-inci-performance"] && !Shopify.designMode) return;
  try {
    
class ImageTabs extends HTMLElement {
  constructor() {
    super();
    this._activeIndex = 0;
    this._onTriggerClick = this._onTriggerClick.bind(this);
    this._onTriggerKeydown = this._onTriggerKeydown.bind(this);
    this._onMobileLabelClick = this._onMobileLabelClick.bind(this);
  }

  connectedCallback() {
    this.triggers = Array.from(this.querySelectorAll('[data-it-trigger]'));
    this.mobileLabels = Array.from(this.querySelectorAll('[data-it-mobile-label]'));
    this.panels = Array.from(this.querySelectorAll('[data-it-panel]'));

    if (!this.panels.length) return;

    const initial = this.panels.findIndex(p => p.getAttribute('data-active') === 'true');
    this._activeIndex = initial >= 0 ? initial : 0;

    this.triggers.forEach(btn => {
      btn.addEventListener('click', this._onTriggerClick);
      btn.addEventListener('keydown', this._onTriggerKeydown);
    });
    this.mobileLabels.forEach(btn => {
      btn.addEventListener('click', this._onMobileLabelClick);
    });

    this.setActive(this._activeIndex, { focusTrigger: false });
  }

  _onTriggerClick(e) {
    const idx = parseInt(e.currentTarget.dataset.index, 10);
    if (!Number.isNaN(idx)) this.setActive(idx, { focusTrigger: false });
  }

  _onMobileLabelClick(e) {
    const btn = e.currentTarget;
    const idx = parseInt(btn.dataset.index, 10);
    if (Number.isNaN(idx)) return;
    const isOpening = idx !== this._activeIndex;
    const prevIdx = this._activeIndex;

    if (isOpening && window.innerWidth <= 1024 && prevIdx >= 0) {
      const prevInner = this.panels[prevIdx] && this.panels[prevIdx].querySelector('.image-tabs__panel-inner');
      if (prevInner) prevInner.style.transition = 'none';
    }

    this.setActive(idx === this._activeIndex ? -1 : idx, { focusTrigger: false });

    if (isOpening && window.innerWidth <= 1024) {
      requestAnimationFrame(() => {
        if (prevIdx >= 0 && this.panels[prevIdx]) {
          const prevInner = this.panels[prevIdx].querySelector('.image-tabs__panel-inner');
          if (prevInner) prevInner.style.transition = '';
        }
        btn.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  _onTriggerKeydown(e) {
    const currentIdx = this.triggers.indexOf(e.currentTarget);
    if (currentIdx < 0) return;
    let nextIdx = null;
    switch (e.key) {
      case 'ArrowDown':
      case 'ArrowRight':
        nextIdx = (currentIdx + 1) % this.triggers.length;
        break;
      case 'ArrowUp':
      case 'ArrowLeft':
        nextIdx = (currentIdx - 1 + this.triggers.length) % this.triggers.length;
        break;
      case 'Home':
        nextIdx = 0;
        break;
      case 'End':
        nextIdx = this.triggers.length - 1;
        break;
      default:
        return;
    }
    e.preventDefault();
    this.setActive(nextIdx, { focusTrigger: true });
  }

  setActive(index, opts) {
    this._activeIndex = index;

    this.triggers.forEach((btn, i) => {
      const isActive = i === index;
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      btn.setAttribute('tabindex', isActive ? '0' : '-1');
      btn.classList.toggle('is-active', isActive);
    });

    this.mobileLabels.forEach((btn, i) => {
      btn.setAttribute('aria-expanded', i === index ? 'true' : 'false');
      btn.classList.toggle('is-open', i === index);
    });

    this.panels.forEach((panel, i) => {
      panel.setAttribute('data-active', i === index ? 'true' : 'false');
    });

    if (opts && opts.focusTrigger && this.triggers[index]) {
      this.triggers[index].focus();
    }

    this.dispatchEvent(new CustomEvent('image-tabs:change', {
      detail: { index, sectionId: this.dataset.sectionId },
      bubbles: true,
    }));

    if (window.isFlutterInAppWebViewReady && window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler('StikkyHeight', document.body.scrollHeight);
    }
  }
}

if (!customElements.get('image-tabs')) {
  customElements.define('image-tabs', ImageTabs);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image_tabs"] && !Shopify.designMode) return;
  try {
    
class ImageTabs extends HTMLElement {
  constructor() {
    super();
    this._activeIndex = 0;
    this._onTriggerClick = this._onTriggerClick.bind(this);
    this._onTriggerKeydown = this._onTriggerKeydown.bind(this);
    this._onMobileLabelClick = this._onMobileLabelClick.bind(this);
  }

  connectedCallback() {
    this.triggers = Array.from(this.querySelectorAll('[data-it-trigger]'));
    this.mobileLabels = Array.from(this.querySelectorAll('[data-it-mobile-label]'));
    this.panels = Array.from(this.querySelectorAll('[data-it-panel]'));

    if (!this.panels.length) return;

    const initial = this.panels.findIndex(p => p.getAttribute('data-active') === 'true');
    this._activeIndex = initial >= 0 ? initial : 0;

    this.triggers.forEach(btn => {
      btn.addEventListener('click', this._onTriggerClick);
      btn.addEventListener('keydown', this._onTriggerKeydown);
    });
    this.mobileLabels.forEach(btn => {
      btn.addEventListener('click', this._onMobileLabelClick);
    });

    this.setActive(this._activeIndex, { focusTrigger: false });
  }

  _onTriggerClick(e) {
    const idx = parseInt(e.currentTarget.dataset.index, 10);
    if (!Number.isNaN(idx)) this.setActive(idx, { focusTrigger: false });
  }

  _onMobileLabelClick(e) {
    const btn = e.currentTarget;
    const idx = parseInt(btn.dataset.index, 10);
    if (Number.isNaN(idx)) return;
    const isOpening = idx !== this._activeIndex;
    const prevIdx = this._activeIndex;

    if (isOpening && window.innerWidth <= 1024 && prevIdx >= 0) {
      const prevInner = this.panels[prevIdx] && this.panels[prevIdx].querySelector('.image-tabs__panel-inner');
      if (prevInner) prevInner.style.transition = 'none';
    }

    this.setActive(idx === this._activeIndex ? -1 : idx, { focusTrigger: false });

    if (isOpening && window.innerWidth <= 1024) {
      requestAnimationFrame(() => {
        if (prevIdx >= 0 && this.panels[prevIdx]) {
          const prevInner = this.panels[prevIdx].querySelector('.image-tabs__panel-inner');
          if (prevInner) prevInner.style.transition = '';
        }
        btn.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  _onTriggerKeydown(e) {
    const currentIdx = this.triggers.indexOf(e.currentTarget);
    if (currentIdx < 0) return;
    let nextIdx = null;
    switch (e.key) {
      case 'ArrowDown':
      case 'ArrowRight':
        nextIdx = (currentIdx + 1) % this.triggers.length;
        break;
      case 'ArrowUp':
      case 'ArrowLeft':
        nextIdx = (currentIdx - 1 + this.triggers.length) % this.triggers.length;
        break;
      case 'Home':
        nextIdx = 0;
        break;
      case 'End':
        nextIdx = this.triggers.length - 1;
        break;
      default:
        return;
    }
    e.preventDefault();
    this.setActive(nextIdx, { focusTrigger: true });
  }

  setActive(index, opts) {
    this._activeIndex = index;

    this.triggers.forEach((btn, i) => {
      const isActive = i === index;
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      btn.setAttribute('tabindex', isActive ? '0' : '-1');
      btn.classList.toggle('is-active', isActive);
    });

    this.mobileLabels.forEach((btn, i) => {
      btn.setAttribute('aria-expanded', i === index ? 'true' : 'false');
      btn.classList.toggle('is-open', i === index);
    });

    this.panels.forEach((panel, i) => {
      panel.setAttribute('data-active', i === index ? 'true' : 'false');
    });

    if (opts && opts.focusTrigger && this.triggers[index]) {
      this.triggers[index].focus();
    }

    this.dispatchEvent(new CustomEvent('image-tabs:change', {
      detail: { index, sectionId: this.dataset.sectionId },
      bubbles: true,
    }));

    if (window.isFlutterInAppWebViewReady && window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler('StikkyHeight', document.body.scrollHeight);
    }
  }
}

if (!customElements.get('image-tabs')) {
  customElements.define('image-tabs', ImageTabs);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-routine-LP"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BREAKPOINT = 1024;
    function syncActiveStepText(slider) {
      if (window.innerWidth > BREAKPOINT) return;
      var routineRoot = slider.closest('.product-routine');
      if (!routineRoot) return;
      var stepTexts = routineRoot.querySelectorAll('.skincare-step-text-mobile .skincare-step-text[data-step]');
      var stepNumbers = routineRoot.querySelectorAll('.skincare-step-number[data-step]');
      if (!stepTexts.length) return;
      var activeStep = null;
      var selectedSlide = slider.querySelector('cs-slide.is-selected, cs-slide.is_selected');
      if (selectedSlide) activeStep = selectedSlide.getAttribute('data-step');
      if (slider.embla && typeof slider.embla.selectedScrollSnap === 'function') {
        var slides = slider.querySelectorAll('cs-slide');
        var selectedIndex = slider.embla.selectedScrollSnap();
        if (!activeStep && slides[selectedIndex]) activeStep = slides[selectedIndex].getAttribute('data-step');
      }
      if (!activeStep) {
        selectedSlide = slider.querySelector('cs-slide');
        if (selectedSlide) activeStep = selectedSlide.getAttribute('data-step');
      }
      if (!activeStep) return;
      stepTexts.forEach(function (t) { t.classList.toggle('active', t.getAttribute('data-step') === activeStep); });
      stepNumbers.forEach(function (n) { n.classList.toggle('active', n.getAttribute('data-step') === activeStep); });
    }
    function bindStepTextSync(slider) {
      var sync = function () { syncActiveStepText(slider); };
      if (slider.embla && typeof slider.embla.on === 'function') {
        slider.embla.on('select', sync);
        slider.embla.on('reInit', sync);
        slider.embla.on('settle', sync);
      } else {
        slider.addEventListener('init', sync, { once: true });
      }
      var slides = slider.querySelector('cs-slides');
      if (slides && typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(sync);
        observer.observe(slides, { subtree: true, attributes: true, attributeFilter: ['class'] });
      }
      sync();
      setTimeout(sync, 0);
    }
    function jumpToActive(slider) {
      if (window.innerWidth > BREAKPOINT) return;
      var step = parseInt(slider.getAttribute('data-active-step-mobile'), 10);
      if (!step || step <= 1) return;
      var slides = slider.querySelectorAll('cs-slide');
      var targetIndex = -1;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-step') === String(step)) { targetIndex = i; break; }
      }
      if (targetIndex < 0) return;
      var go = function () {
        if (slider.embla && typeof slider.embla.scrollTo === 'function') slider.embla.scrollTo(targetIndex, true);
      };
      if (slider.embla) { go(); } else { slider.addEventListener('init', go, { once: true }); }
    }
    function applyAll() {
      document.querySelectorAll('.product-routine__slider-inner[data-active-step-mobile]').forEach(function (slider) {
        jumpToActive(slider);
        bindStepTextSync(slider);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyAll, { once: true });
    } else {
      applyAll();
    }

    // Routine / Set Toggle
    document.querySelectorAll('.shopify-section-product-routine .product-routine__toggle button').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var root = btn.closest('.product-routine');
        var target = btn.getAttribute('data-target');
        root.querySelectorAll('.product-routine__toggle button').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var slider = root.querySelector('.product-routine__slider');
        var steps = root.querySelector('.skincare-steps');
        var stepsMobile = root.querySelector('.skincare-step-text-mobile');
        var setView = root.querySelector('.product-routine__set');
        var atcAll = root.querySelector('.product-routine__atc-all');
        if (target === 'set') {
          if (slider) slider.style.display = 'none';
          if (steps) steps.style.display = 'none';
          if (stepsMobile) stepsMobile.style.display = 'none';
          if (atcAll) atcAll.style.display = 'none';
          if (setView) setView.classList.add('active');
        } else {
          if (slider) slider.style.display = '';
          if (steps) steps.style.display = '';
          if (stepsMobile) stepsMobile.style.display = '';
          if (atcAll) atcAll.style.display = '';
          if (setView) setView.classList.remove('active');
        }
      });
    });

    // Desktop: keep open until click outside
    document.addEventListener('click', function(e) {
      document.querySelectorAll('routine-button').forEach(function(rb) {
        if (!rb.contains(e.target) && rb._containerEl && !rb._containerEl.contains(e.target)) {
          rb._hide();
        }
      });
    });
    document.querySelectorAll('routine-button').forEach(function(rb) {
      var origScheduleHide = rb._scheduleHide.bind(rb);
      rb._scheduleHide = function() {
        if (!rb._isMobile()) return;
        origScheduleHide();
      };
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-routine"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BREAKPOINT = 1024;
    function syncActiveStepText(slider) {
      if (window.innerWidth > BREAKPOINT) return;
      var routineRoot = slider.closest('.product-routine');
      if (!routineRoot) return;
      var stepTexts = routineRoot.querySelectorAll('.skincare-step-text-mobile .skincare-step-text[data-step]');
      var stepNumbers = routineRoot.querySelectorAll('.skincare-step-number[data-step]');
      if (!stepTexts.length) return;

      var activeStep = null;
      var selectedSlide = slider.querySelector('cs-slide.is-selected, cs-slide.is_selected');
      if (selectedSlide) {
        activeStep = selectedSlide.getAttribute('data-step');
      }
      if (slider.embla && typeof slider.embla.selectedScrollSnap === 'function') {
        var slides = slider.querySelectorAll('cs-slide');
        var selectedIndex = slider.embla.selectedScrollSnap();
        if (!activeStep && slides[selectedIndex]) {
          activeStep = slides[selectedIndex].getAttribute('data-step');
        }
      }
      if (!activeStep) {
        selectedSlide = slider.querySelector('cs-slide');
        if (selectedSlide) {
          activeStep = selectedSlide.getAttribute('data-step');
        }
      }
      if (!activeStep) return;

      stepTexts.forEach(function (stepText) {
        stepText.classList.toggle('active', stepText.getAttribute('data-step') === activeStep);
      });
      stepNumbers.forEach(function (stepNumber) {
        stepNumber.classList.toggle('active', stepNumber.getAttribute('data-step') === activeStep);
      });
    }

    function bindStepTextSync(slider) {
      var sync = function () {
        syncActiveStepText(slider);
      };

      if (slider.embla && typeof slider.embla.on === 'function') {
        slider.embla.on('select', sync);
        slider.embla.on('reInit', sync);
        slider.embla.on('settle', sync);
      } else {
        slider.addEventListener('init', sync, { once: true });
      }

      var slides = slider.querySelector('cs-slides');
      if (slides && typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(sync);
        observer.observe(slides, { subtree: true, attributes: true, attributeFilter: ['class'] });
      }

      sync();
      setTimeout(sync, 0);
    }

    function jumpToActive(slider) {
      if (window.innerWidth > BREAKPOINT) return;
      var step = parseInt(slider.getAttribute('data-active-step-mobile'), 10);
      if (!step || step <= 1) return;
      var slides = slider.querySelectorAll('cs-slide');
      var targetIndex = -1;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-step') === String(step)) {
          targetIndex = i;
          break;
        }
      }
      if (targetIndex < 0) return;
      var go = function () {
        if (slider.embla && typeof slider.embla.scrollTo === 'function') {
          slider.embla.scrollTo(targetIndex, true);
        }
      };
      if (slider.embla) {
        go();
      } else {
        slider.addEventListener('init', go, { once: true });
      }
    }
    function applyAll() {
      document
        .querySelectorAll('.product-routine__slider-inner[data-active-step-mobile]')
        .forEach(function (slider) {
          jumpToActive(slider);
          bindStepTextSync(slider);
        });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyAll, { once: true });
    } else {
      applyAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["result-routine-slider-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BREAKPOINT = 1024;

    function visibleSliders(root) {
      var out = [];
      root.querySelectorAll('clever-slider').forEach(function (slider) {
        var wrap = slider.closest('[routine_results_large_version], [routine_results_mini_version]');
        if (!wrap || getComputedStyle(wrap).display !== 'none') {
          out.push(slider);
        }
      });
      return out;
    }

    function syncActiveStep(root, slider) {
      if (window.innerWidth > BREAKPOINT) return;
      if (!slider) return;

      var activeStep = null;
      var selectedSlide = slider.querySelector('cs-slide.is-selected, cs-slide.is_selected');
      if (selectedSlide) {
        activeStep = selectedSlide.getAttribute('data-step');
      }
      if (!activeStep && slider.embla && typeof slider.embla.selectedScrollSnap === 'function') {
        var slides = slider.querySelectorAll('cs-slide');
        var idx = slider.embla.selectedScrollSnap();
        if (slides[idx]) activeStep = slides[idx].getAttribute('data-step');
      }
      if (!activeStep) {
        selectedSlide = slider.querySelector('cs-slide');
        if (selectedSlide) activeStep = selectedSlide.getAttribute('data-step');
      }
      if (!activeStep) return;

      root.querySelectorAll('.skincare-step-number[data-step]').forEach(function (el) {
        el.classList.toggle('active', el.getAttribute('data-step') === activeStep);
      });
      root.querySelectorAll('.skincare-step-text[data-step]').forEach(function (el) {
        el.classList.toggle('active', el.getAttribute('data-step') === activeStep);
      });
    }

    function bindSlider(root, slider) {
      var sync = function () { syncActiveStep(root, slider); };
      if (slider.embla && typeof slider.embla.on === 'function') {
        slider.embla.on('select', sync);
        slider.embla.on('reInit', sync);
        slider.embla.on('settle', sync);
      } else {
        slider.addEventListener('init', sync, { once: true });
      }
      var slides = slider.querySelector('cs-slides');
      if (slides && typeof MutationObserver !== 'undefined') {
        new MutationObserver(sync).observe(slides, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });
      }
      sync();
      setTimeout(sync, 0);
    }

    function jumpToActive(slider) {
      if (window.innerWidth > BREAKPOINT) return;
      var step = parseInt(slider.getAttribute('data-active-step-mobile'), 10);
      if (!step || step <= 1) return;
      var slides = slider.querySelectorAll('cs-slide');
      var targetIndex = -1;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-step') === String(step)) {
          targetIndex = i;
          break;
        }
      }
      if (targetIndex < 0) return;
      var go = function () {
        if (slider.embla && typeof slider.embla.scrollTo === 'function') {
          slider.embla.scrollTo(targetIndex, true);
        }
      };
      if (slider.embla) {
        go();
      } else {
        slider.addEventListener('init', go, { once: true });
      }
    }

    function bindToggle(root) {
      var toggle = root.querySelector('[data-routine-size-toggle]');
      if (!toggle) return;
      var hasMini = root.querySelector('[routine_results_mini_version]') !== null;
      if (!hasMini) {
        toggle.style.display = 'none';
        return;
      }

      var activeBtn = toggle.querySelector('.size-toggle__btn.is-active');
      var initialSize = activeBtn ? activeBtn.getAttribute('data-size') : 'large';
      if (initialSize === 'mini') {
        document.body.setAttribute('pf_mini_results', '');
      } else {
        document.body.removeAttribute('pf_mini_results');
      }

      var buttons = toggle.querySelectorAll('.size-toggle__btn');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-size');
          if (target === 'mini') {
            document.body.setAttribute('pf_mini_results', '');
          } else {
            document.body.removeAttribute('pf_mini_results');
          }
          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');

          setTimeout(function () {
            visibleSliders(root).forEach(function (s) {
              if (s.embla && typeof s.embla.reInit === 'function') {
                s.embla.reInit();
              }
              jumpToActive(s);
              syncActiveStep(root, s);
            });
          }, 50);
        });
      });
    }

    function initRoot(root) {
      root.querySelectorAll('clever-slider[data-active-step-mobile]').forEach(function (slider) {
        bindSlider(root, slider);
        jumpToActive(slider);
      });
      bindToggle(root);
      var visible = visibleSliders(root);
      if (visible.length) syncActiveStep(root, visible[0]);
    }

    function init() {
      document.querySelectorAll('.result-routine-v2').forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["routine-day-night"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BREAKPOINT = 1024;

    function syncActiveStep(root, slider) {
      if (window.innerWidth > BREAKPOINT) return;
      if (!slider) return;
      var activeStep = null;
      var selectedSlide = slider.querySelector('cs-slide.is-selected, cs-slide.is_selected');
      if (selectedSlide) activeStep = selectedSlide.getAttribute('data-step');
      if (!activeStep && slider.embla && typeof slider.embla.selectedScrollSnap === 'function') {
        var slides = slider.querySelectorAll('cs-slide');
        var idx = slider.embla.selectedScrollSnap();
        if (slides[idx]) activeStep = slides[idx].getAttribute('data-step');
      }
      if (!activeStep) {
        selectedSlide = slider.querySelector('cs-slide');
        if (selectedSlide) activeStep = selectedSlide.getAttribute('data-step');
      }
      if (!activeStep) return;
      root.querySelectorAll('.rdn-step-number[data-step]').forEach(function (el) {
        el.classList.toggle('active', el.getAttribute('data-step') === activeStep);
      });
      root.querySelectorAll('.rdn-step-text[data-step]').forEach(function (el) {
        el.classList.toggle('active', el.getAttribute('data-step') === activeStep);
      });
    }

    function bindSlider(root, slider) {
      var sync = function () { syncActiveStep(root, slider); };
      var initialStep = parseInt(slider.getAttribute('data-active-step-mobile'), 10);
      var boundAt = Date.now();
      var reapplyInitialIfEarly = function () {
        if (window.innerWidth > BREAKPOINT) return;
        if (!initialStep || initialStep <= 1) return;
        if (Date.now() - boundAt > 4000) return; // nur kurz nach dem Laden, nicht bei späterem Swipen
        scrollToStep(slider, initialStep, false);
      };
      if (slider.embla && typeof slider.embla.on === 'function') {
        slider.embla.on('select', sync);
        slider.embla.on('reInit', function () { reapplyInitialIfEarly(); sync(); });
        slider.embla.on('settle', sync);
      } else {
        slider.addEventListener('init', sync, { once: true });
      }
      var slides = slider.querySelector('cs-slides');
      if (slides && typeof MutationObserver !== 'undefined') {
        new MutationObserver(sync).observe(slides, { subtree: true, attributes: true, attributeFilter: ['class'] });
      }
      sync();
      setTimeout(sync, 0);
    }

    function scrollToStep(slider, step, animate, attemptsLeft, settle) {
      var slides = slider.querySelectorAll('cs-slide');
      var targetIndex = -1;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-step') === String(step)) { targetIndex = i; break; }
      }
      if (targetIndex < 0) return;

      if (slider.embla && typeof slider.embla.scrollTo === 'function') {
        slider.embla.scrollTo(targetIndex, animate);
        // Ein Nach-Schlag nach kurzer Verzögerung: falls Embla beim ersten Aufruf die
        // Breiten noch nicht final berechnet hatte, korrigiert dieser zweite Aufruf das.
        if (!settle) {
          setTimeout(function () { scrollToStep(slider, step, true, 0, true); }, 250);
        }
        return;
      }

      // Embla ist noch nicht bereit — statt auf ein bestimmtes Event zu warten (dessen exakter
      // Name/Zeitpunkt bei clever-slider nicht sicher ist), einfach kurz erneut prüfen.
      if (typeof attemptsLeft === 'undefined') attemptsLeft = 40; // ~4s bei 100ms Abstand
      if (attemptsLeft <= 0) return;
      setTimeout(function () {
        scrollToStep(slider, step, animate, attemptsLeft - 1, settle);
      }, 100);
    }

    function jumpToActive(slider) {
      if (window.innerWidth > BREAKPOINT) return;
      var step = parseInt(slider.getAttribute('data-active-step-mobile'), 10);
      if (!step || step <= 1) return;
      scrollToStep(slider, step, true);
    }

    // Klick auf eine Step-Zahl (mobil) springt im Carousel zum jeweiligen Produkt.
    // Auf Desktop existiert kein Carousel an dieser Stelle, der Klick bleibt dort wirkungslos.
    function bindStepClicks(block, slider) {
      block.querySelectorAll('.rdn-step-cell[data-step]').forEach(function (cell) {
        cell.addEventListener('click', function () {
          if (window.innerWidth > BREAKPOINT) return;
          scrollToStep(slider, cell.getAttribute('data-step'), false);
        });
      });
    }

    function initBlock(block) {
      if (block.dataset.rdnInit) return;
      block.dataset.rdnInit = '1';
      block.querySelectorAll('clever-slider[data-active-step-mobile]').forEach(function (slider) {
        bindSlider(block, slider);
        jumpToActive(slider);
        bindStepClicks(block, slider);
        // Extra expliziter Sync direkt nach dem Binden: Zahlen-Kachel UND Wort werden hier
        // in derselben Funktion, im selben Aufruf gesetzt — beide können nur gemeinsam
        // falsch oder richtig sein, nie eins von beiden allein.
        syncActiveStep(block, slider);
      });
    }

    function init() {
      document.querySelectorAll('.rdn-block').forEach(initBlock);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    // Theme-Editor lädt die Section per AJAX neu (kein DOMContentLoaded) — ohne das hier
    // bleibt eine frisch nachgeladene Instanz komplett unverdrahtet (kein Klick, kein Sync).
    // init() ist dank der rdnInit-Markierung idempotent, kann also gefahrlos erneut laufen.
    document.addEventListener('shopify:section:load', init);

    // routine-button: Desktop offen halten bis Klick außerhalb, Auto-Hide nur auf Mobile
    // (identisches Verhalten zu Product Routine — harmlos falls beide Sections auf einer Seite sind)
    document.addEventListener('click', function(e) {
      document.querySelectorAll('.rdn-block routine-button').forEach(function(rb) {
        if (!rb.contains(e.target) && rb._containerEl && !rb._containerEl.contains(e.target)) {
          if (typeof rb._hide === 'function') rb._hide();
        }
      });
    });
    document.querySelectorAll('.rdn-block routine-button').forEach(function(rb) {
      if (typeof rb._scheduleHide !== 'function' || rb._rdnPatched) return;
      rb._rdnPatched = true;
      var origScheduleHide = rb._scheduleHide.bind(rb);
      rb._scheduleHide = function() {
        if (typeof rb._isMobile === 'function' && !rb._isMobile()) return;
        origScheduleHide();
      };
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
